import { Error } from '@redux/common/types';
import { ReduxState } from '@redux/types';
import { createLLMPromptActions, getLLMPromptByIdActions, getLLMPromptsActions, updateLLMPromptActions, deleteLLMPromptActions } from './llmPromptsActions';
import { LLMPrompt } from './llmPromptsTypes';

export const getLLMPromptsStateSelector = (state: ReduxState) => {
  return state.llmPrompts;
};

export const getLLMPromptsByIdSelector = (state: ReduxState): Record<string, LLMPrompt> => {
  return getLLMPromptsStateSelector(state).llmPromptsById;
};

export const getLLMPromptsArraySelector = (state: ReduxState): LLMPrompt[] => {
  const llmPromptsById = getLLMPromptsByIdSelector(state);
  return Object.values(llmPromptsById);
};

export const getIsLoadingSelector = (state: ReduxState): Record<string, boolean> => {
  return getLLMPromptsStateSelector(state).isLoading;
};

export const isLoadingGetLLMPromptsSelector = (state: ReduxState): boolean => {
  return getIsLoadingSelector(state)[getLLMPromptsActions.start.type] || false;
};

export const isLoadingGetLLMPromptByIdSelector = (state: ReduxState): boolean => {
  return getIsLoadingSelector(state)[getLLMPromptByIdActions.start.type] || false;
};

export const isLoadingCreateLLMPromptSelector = (state: ReduxState): boolean => {
  return getIsLoadingSelector(state)[createLLMPromptActions.start.type] || false;
};

export const isLoadingUpdateLLMPromptSelector = (state: ReduxState): boolean => {
  return getIsLoadingSelector(state)[updateLLMPromptActions.start.type] || false;
};

export const isLoadingDeleteLLMPromptSelector = (state: ReduxState): boolean => {
  return getIsLoadingSelector(state)[deleteLLMPromptActions.start.type] || false;
};

export const getErrorSelector = (state: ReduxState): Record<string, Error> => {
  return getLLMPromptsStateSelector(state).error;
};

export const getSuccessSelector = (state: ReduxState): Record<string, boolean> => {
  return getLLMPromptsStateSelector(state).success;
};
